// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import { CREDIT_NOTE_LINE_STATE, CREDIT_NOTE_LINE_FORM_FIELDS } from "./CreditNote.utils";
//Third party
import GoInlineField from "../../../components/Inputs/GoInlineField";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
import toast from "react-hot-toast";
import { TableRow, TableCell } from "@mui/material";

const CreditNoteLine = ({ values, touched, errors, handleChange, creditNoteId, creditNoteLineId, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [credit_note_line, setCreditNoteLine] = useState(CREDIT_NOTE_LINE_STATE);
    const [formFields, setFormFields] = useState(CREDIT_NOTE_LINE_FORM_FIELDS);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "autocomplete")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const handleAccountChange = async () => {
        spinService.on();
        const response = await get(EntityConstants.ACCOUNTS, "max=all");
        const data = await response.json();
        attachOptions("debit_ledger_id", data);
        spinService.off();
    };

    const handleCreditNoteLineChange = async (creditNoteLineId) => {
        spinService.on();
        const response = await get(EntityConstants.CREDIT_NOTE_LINES + `/${creditNoteLineId}`);
        const data = await response.json();
        setCreditNoteLine(data);
        spinService.off();
    };

    const handleValueChange = (e, values) => {
        console.log(e);
        console.log(values);
    };

    useEffect(() => {
        handleAccountChange();
        if (creditNoteLineId !== undefined) {
            handleCreditNoteLineChange(creditNoteLineId);
        }
        return () => {
            setCreditNoteLine({});
        }
    }, []);

    return (
        <TableRow
            hover
            key={"action_row"}
            tabIndex={-1}
            role="checkbox"
        >
            {formFields.map((formField, index) => {
                return (
                    <TableCell
                        colSpan={formField.colSpan === undefined ? 1 : formField.colSpan}
                        key={"col" + index}
                    // align={col.align}
                    >
                        <GoInlineField
                            config={formField}
                            values={values}
                            touched={touched}
                            errors={errors}
                            handleChange={(e) => { handleChange(e); handleValueChange(e, values); }}
                            onClose={() => onClose()}
                        />
                    </TableCell>
                );
            })}
        </TableRow>
    );
};

CreditNoteLine.propTypes = {
    creditNoteId: PropTypes.any,
    creditNoteLineId: PropTypes.any,
    onClose: PropTypes.any,
};

export default CreditNoteLine;